export { default } from "./ProductLike";
